<div class="table-container-scroll mat-elevation-z2 m-4 bg-white">
  <section class="mt-2">
    <div class="d-flex align-items-center p-2">
      <button
        mat-button
        class="back-icon text-muted me-2 mat-elevation-z8"
        (click)="goBack()"
      >
        <mat-icon class="back-mat-icon">keyboard_backspace</mat-icon>
      </button>
      <h4 class="p-2">
        <!-- Showing search Results of {{ page }} - {{ results.searchResults.length }} -->
      </h4>
      <hr />
    </div>
  </section>
  <section class="example-container table-scroll-region" tabindex="0">
    <mat-table
      [dataSource]="receivedData"
      matSort
      (matSortChange)="onSort($event)"
      class="custom-column-divider modern-table"
    >
      @for (col of resultsColumns; track col.key) {
        <ng-container [matColumnDef]="col.key">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="table-header-cell"
          >
            {{ col.label }}
          </th>

          <td mat-cell *matCellDef="let row" class="table-data-cell">
            @if (col.key === "actions") {
              <div class="actions-col">
                <button mat-menu-item (click)="showDetails(row)">
                  <img
                    src="../../../assets/icons/view_icon.png"
                    width="20px"
                    alt="View details"
                    class="src"
                  />
                </button>
                <!-- <button mat-icon-button [matMenuTriggerFor]="accountActionsMenu" aria-label="deleteInvoice actions">
                  <mat-icon>more_vert</mat-icon>
                </button> -->
              </div>
            }
            @if (col.key === "status" || col.key === "importStatus") {
              <span
                class="table-data-text"
                [ngClass]="{
                  'imported-status': row[col.key] === 'Imported',
                  'error-status':
                    row[col.key] === 'Error' || row[col.key] === 'Failed',
                  'default-status':
                    row[col.key] !== 'Imported' &&
                    row[col.key] !== 'Error' &&
                    row[col.key] !== 'Open' &&
                    row[col.key] !== 'Failed',
                }"
              >
                @if (row[col.key] === "Imported") {
                  <img src="../../../../../assets/icons/Imported.png" alt="" />
                }
                @if (row[col.key] === "Error") {
                  <img src="../../../../../assets/icons/Failed.png" alt="" />
                }
                @if (row[col.key] === "Open") {
                  <img
                    width="60"
                    src="../../../../../assets/icons/Open.png"
                    alt=""
                  />
                }
                @if (
                  row[col.key] !== "Imported" &&
                  row[col.key] !== "Error" &&
                  row[col.key] !== "Open"
                ) {
                  {{ row[col.key] }}
                }
              </span>
            } @else {
              <ng-container>
                {{ row[col.key] }}
              </ng-container>
            }
          </td>
        </ng-container>
      }

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns; sticky: true"
        class="modern-table-header-row"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="modern-table-data-row"
      ></tr>

      <tr class="mat-row no-data-row" *matNoDataRowDef>
        <td
          class="mat-cell"
          [attr.colspan]="results.searchResults.length === 0"
        >
          No data matching the filter.
        </td>
      </tr>
    </mat-table>
  </section>
  <!-- Paginator -->
  <div class="pagination-container bg-white table-pagination-fixed">
    <mat-paginator
      class="bg-white"
      [length]="totalResults"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageOffset]="pageOffset"
      [pageSizeOptions]="pageSizeOptions"
      aria-label="Select page of transactions"
      (page)="onMatPageChange($event)"
    >
      <!-- (pageChange)="onPageChange($event)" -->
    </mat-paginator>
  </div>
</div>
